import { defineServiceConfigProvider } from "@volkswagen-onehub/service-config-provider";
export const serviceConfigProviderFactory = (configs) => {
    const configMap = Object.fromEntries(configs.map((config) => {
        return [
            config.name,
            {
                name: config.name,
                urlOrigin: config.urlOrigin,
            },
        ];
    }));
    return defineServiceConfigProvider({ configs: configMap });
};
